import axios from 'axios'
import store from '../store'
import {logout} from "@/util/LogoutProcess"


const client = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '../APIGateway/api/manageService' : 'http://localhost:8090/api/manageService',
  json: true
})

export default {
  async execute (method, resource, data) {
    // inject the accessToken for each request      
    var accessToken = process.env.NODE_ENV === 'production' ? store.getters["currentUser/getAuthToken"] : '';
    
   //var accessToken=''
    return client({
      method,
      url: resource,
      timeout:3000000,
      data,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }).then(req => {
      return req.data
    }).catch(ex=>{
      if(ex.response?.status==401) {
        if(process.env.NODE_ENV === "production"){
          logout()
        }
        else{
          //when in development mode then reload        
        }
      }
      else {
        throw ex
      }      
    })
  } 
  
}